import { isNotNullable } from '@bayer-int/portletce-shared';
import { minBy } from 'lodash-es';

import type { View, ViewId, FilterDataArray, Specification } from 'portlet/models';

import { FilterData } from '../../filters';
import { define } from './_common';

export const FilterableViewSetting = define({
    filtersToSetting: (filter, { currentFilters, specification }) => {
        const nextViewId = matchViewWithSmartTags(specification, filter, currentFilters);

        return isNotNullable(nextViewId) ? { VIEWID: nextViewId } : null;
    },
});

function matchViewWithSmartTags(
    spec: Specification,
    latestFilter: FilterData,
    filters: FilterDataArray,
): ViewId | null {
    if (!FilterData.is.SMART_VIEW_TAG(latestFilter)) return null;

    const {
        item,
        value: { viewTag },
    } = latestFilter;

    // new view must match with the latest smart view tag
    const matchingViews = spec.views.filter(
        ({ smartViewTags = {} }) => smartViewTags[item] === viewTag,
    );

    // if no view matches the latest smart view tag
    // we do not change the view at all
    if (!matchingViews.length) return null;

    const selectedView = minBy(matchingViews, view => viewTagDistance(view.smartViewTags, filters));

    return selectedView ? selectedView.id : null;
}

function viewTagDistance(viewTags: View['smartViewTags'] = {}, filters: FilterDataArray): number {
    // any smart view tag that does not exist on view or does not match in value increments the measure,
    // therefore, the distance measure is equal to length of unmatched tags
    const unmatchedTags = filters
        .filter(FilterData.is.SMART_VIEW_TAG)
        .filter(({ item, value: { viewTag } }) => !viewTags[item] || viewTags[item] !== viewTag);

    return unmatchedTags.length;
}
